import { Dispatch, SetStateAction } from 'react'
import { Grid, Typography, Button } from '@mui/material'
import { hasKnownCvDates } from '../utils/metropolitanCv'
import { FormType, SessionType } from '../utils/sharedTypes'
import MetropolitanCvNote from './MetropolitanCvNote'

type StartingDatePropsType = {
  form: FormType
  setForm: Dispatch<SetStateAction<FormType>>
  fifplRules?: boolean
}

const isFifplEligible = (session: SessionType): boolean => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const start = new Date(session.starting_date)
  start.setHours(0, 0, 0, 0)
  const diffDays = (start.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  return diffDays > 2
}

const StartingDate = ({ form, setForm, fifplRules = false }: StartingDatePropsType) => {
  const handleChange = (key: string, value: string | boolean | string[] | Record<string, string>) => {
    setForm((prevState) => {
      const errors = prevState.errors
      delete errors[key]
      return {
        ...prevState,
        data: {
          ...prevState.data,
          [key]: value,
        },
        errors: errors,
      }
    })
  }

  const eligibleSessions = fifplRules ? form.sessions.filter(isFifplEligible) : form.sessions
  const showMetropolitanCvNote = hasKnownCvDates({
    product: form.data.product,
    products: form.data.products,
    session: form.data.session,
    sessions: form.sessions,
  })

  if (form.sessions.length === 0) {
    return <Grid item> Pas de session disponible</Grid>
  }

  if (fifplRules && eligibleSessions.length === 0) {
    return <Grid item> Pas de session disponible</Grid>
  }

  return form.data.registration_type == 'PreConfiguredRegistration' ? (
    <Grid item container spacing={2} direction="column">
      <Grid item container spacing={1}>
        {eligibleSessions
          .filter((s) => s.global_id == form.data.session?.global_id)
          .map((session, index) => {
            return (
              <Grid item key={session.global_id} xs={12} md={6}>
                <Button
                  id={`startLater_${index}`}
                  fullWidth
                  sx={{ height: 56 }}
                  variant={form.data.session?.global_id === session.global_id ? 'contained' : 'outlined'}
                  onClick={() => {
                    handleChange('session', { global_id: session.global_id })
                  }}
                >
                  <Grid container direction="column">
                    <Typography variant="body1" sx={{ color: 'inherit' }}>
                      {index === 0 && new Date(session.starting_date) <= new Date()
                        ? 'Commencer tout de suite'
                        : new Date(session.starting_date).toLocaleDateString('fr', { day: '2-digit', month: 'long' })}
                    </Typography>
                    <Typography variant="body2" sx={{ textTransform: 'lowercase' }}>
                      (Fin le{' '}
                      {session.display_ending_date
                        ? new Date(session.display_ending_date).toLocaleDateString('fr', {
                            day: '2-digit',
                            month: 'long',
                          })
                        : new Date(session.ending_date).toLocaleDateString('fr', {
                            day: '2-digit',
                            month: 'long',
                          })}
                      )
                    </Typography>
                  </Grid>
                </Button>
              </Grid>
            )
          })}
      </Grid>
      {showMetropolitanCvNote && (
        <Grid item>
          <MetropolitanCvNote form={form} />
        </Grid>
      )}
    </Grid>
  ) : (
    <Grid item container spacing={2} direction="column">
      <Grid item container spacing={1}>
        {eligibleSessions.slice(0, 4).map((session, index) => {
          return (
            <Grid item key={session.global_id} xs={12} md={6}>
              <Button
                id={`startLater_${index}`}
                fullWidth
                sx={{ height: 56 }}
                variant={form.data.session?.global_id === session.global_id ? 'contained' : 'outlined'}
                onClick={() => {
                  handleChange('session', { global_id: session.global_id })
                }}
              >
                <Grid container direction="column">
                  <Typography variant="body1" sx={{ color: 'inherit' }}>
                    {index === 0 && new Date(session.starting_date) <= new Date()
                      ? 'Commencer tout de suite'
                      : new Date(session.starting_date).toLocaleDateString('fr', { day: '2-digit', month: 'long' })}
                  </Typography>
                  <Typography variant="body2" sx={{ textTransform: 'lowercase' }}>
                    (Fin le{' '}
                    {session.display_ending_date
                      ? new Date(session.display_ending_date).toLocaleDateString('fr', {
                          day: '2-digit',
                          month: 'long',
                        })
                      : new Date(session.ending_date).toLocaleDateString('fr', {
                          day: '2-digit',
                          month: 'long',
                        })}
                    )
                  </Typography>
                </Grid>
              </Button>
            </Grid>
          )
        })}
      </Grid>
      {showMetropolitanCvNote && (
        <Grid item>
          <MetropolitanCvNote form={form} />
        </Grid>
      )}
    </Grid>
  )
}

export default StartingDate
